
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { IntroAnimation } from "../../independent/intro/IntroAnimation";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";

export class IntroPresentation extends Presentation {

    private introPLayed:boolean = false;

    public checkForActivation():boolean{ return true };

    public isActive():boolean{ return !this.introPLayed; };

    public getPresentation(){

        if(!SlotGame.api.gameClientConfiguration.useCensoredGfxUS)
            IntroAnimation.instance.play();
        
        this.introPLayed = true;

        this.PresentationState.set(PresentationState.INACTIVE);
    }
}